export function determineIfRequiredActionsPresent (ticketTypes) {
  if (!ticketTypes || (ticketTypes.length === 0)) return false
  return ticketTypes.some(ticketType => (
    ticketType.requireAddAsset ||
    ticketType.requireRemoveAsset ||
    ticketType.requireEnterWeight ||
    ticketType.requireAddImage
  ))
}
